import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttachHypothesisFileParams, HypothesisFilesData} from "../types/hypothesis-modal.types";
import {baseUrl} from "../../../../constants/base-url";
import {hypothesisFilesPath} from "../configs/hypothesis-modal-config";
import {UpdateFieldCommentFile} from "../../../../types/file.types";
import {jsonPathHeaders} from "../../../../models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class HypothesisFilesApiService {
  private http = inject(HttpClient);
  private url = `${baseUrl}/${hypothesisFilesPath}`;

  public getHypothesisFiles(hypothesisId: number): Observable<Array<HypothesisFilesData>> {
    return this.http.get<Array<HypothesisFilesData>>(`${this.url}`, { params: { hypothesisId: hypothesisId } });
  }

  public attachHypothesisFile(attachHypothesisFileParams: AttachHypothesisFileParams): Observable<HypothesisFilesData> {
    return this.http.post<HypothesisFilesData>(`${this.url}`, attachHypothesisFileParams);
  }

  public updateCommentHypothesisFile({id, comment }: UpdateFieldCommentFile): Observable<HypothesisFilesData> {
    const patchOperations = [{
      'op': 'add',
      'path': `/comment`,
      'value': comment
    }];

    return this.http.patch<HypothesisFilesData>(`${this.url}/${id}`, patchOperations, {
      headers: jsonPathHeaders
    });
  }

  public deleteHypothesisFile(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
